export enum RolesEnum { 
    ADMIN = 'admin',
    COMPANY = 'company',
    INFLUENCER = 'influencer',
    USER = 'user',
}